import { apiClient } from './api';
import type {
  WarmupTemplate,
  WarmupPlan,
  CreateWarmupTemplateInput,
  ApiCollection,
} from './types';

const ENDPOINT = '/api/warmup_templates';

export class WarmupService {
  static async getWarmupPlan(sessionId: number): Promise<WarmupPlan> {
    const response = await apiClient.get<WarmupPlan>(
      `/api/workout-sessions/${sessionId}/warmup-plan`
    );
    return response.data;
  }

  static async listTemplates(): Promise<WarmupTemplate[]> {
    const response = await apiClient.get<ApiCollection<WarmupTemplate>>(ENDPOINT);
    return response.data['member'];
  }

  static async createTemplate(data: CreateWarmupTemplateInput): Promise<WarmupTemplate> {
    const response = await apiClient.post<WarmupTemplate>(ENDPOINT, data);
    return response.data;
  }

  static async updateTemplate(
    id: number,
    data: Partial<CreateWarmupTemplateInput>
  ): Promise<WarmupTemplate> {
    const response = await apiClient.patch<WarmupTemplate>(`${ENDPOINT}/${id}`, data);
    return response.data;
  }

  static async deleteTemplate(id: number): Promise<void> {
    await apiClient.delete(`${ENDPOINT}/${id}`);
  }
}
